import { DownloadOutlined } from '@mui/icons-material'
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material'
import { DeleteButtonWithConfirmation } from 'components/Common/Button/DeleteButtonWithConfirmation'
import { useDateString } from 'model/DateString'
import { useTranslation } from 'react-i18next'
import { AttachmentDetailsProps } from './AttachmentDetailsProps'

export const AttachmentList = (props: AttachmentDetailsProps) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const dateString = useDateString()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        gap: '1rem',
        height: '100%',
        borderTop: `1px solid ${theme.palette.divider}`,
        paddingTop: theme.spacing(2),
      }}
    >
      {props.noTitle ? null : (
        <div
          style={{
            display: 'flex',
            gap: theme.spacing(2),
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          <Typography
            variant="h6"
            style={{
              paddingLeft: theme.spacing(2),
            }}
          >
            {t('project:attachments', 'attachments')}
          </Typography>
        </div>
      )}
      <TableContainer
        sx={{
          overflow: 'auto',
        }}
      >
        <Table size="small" padding="normal">
          <TableHead>
            <TableRow>
              {/* <TableCell align="center"></TableCell> */}
              <TableCell align="left">
                {t('project:file-name', 'file name')}
              </TableCell>
              <TableCell align="center">
                {t('project:file-type', 'type')}
              </TableCell>
              <TableCell align="center">
                {t('project:created-at', 'created at')}
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.filteredAttachments?.map((attachment) => (
              <TableRow key={attachment.id}>
                {/* <TableCell align="center">
                  {attachment.originalFileName
                    ?.toLowerCase()
                    .endsWith('.pdf') ? (
                    <div
                      style={{
                        position: 'relative',
                        minWidth: '32px',
                        width: '300px',
                        height: '200px',
                        overflow: 'hidden',
                        textAlign: 'center',
                      }}
                    >
                      <AttachmentPreview
                        bomItemPointer={props.bomItemPointer}
                        fileName={attachment.originalFileName}
                        pdfViewModel={props.pdfViewModel}
                        attachmentId={attachment.id}
                        loading={props.loading}
                        setPdfViewModel={props.setPdfViewModel}
                        thumbnailFileName={attachment.thumbnail}
                        onClick={() => {
                          props.onOpenDrawings(attachment.id)
                        }}
                      />
                    </div>
                  ) : null}
                </TableCell> */}
                <TableCell align="left" width="100%">
                  <Typography variant="body2" style={{ textWrap: 'wrap' }}>
                    {attachment.originalFileName}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" noWrap>
                    {attachment.originalFileName.substring(
                      attachment.originalFileName.lastIndexOf('.'),
                    )}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" noWrap color="textSecondary">
                    {dateString(attachment.dateCreated)}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <div
                    style={{
                      display: 'flex',
                      gap: theme.spacing(1),
                      justifyContent: 'flex-end',
                    }}
                  >
                    <DeleteButtonWithConfirmation
                      onDelete={() => props.onDelete(attachment)}
                      buttonType="icon"
                    />
                    <IconButton
                      onClick={() => {
                        props.onDownload(attachment)
                      }}
                      size="small"
                      color="primary"
                      title="Download"
                    >
                      <DownloadOutlined />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
